// extracted by mini-css-extract-plugin
export default {"main":"Avatar_main__ZCi4Y","initial":"Avatar_initial__AN-k0","selected":"Avatar_selected__sNkYa","loading":"Avatar_loading__MqDdX"};